document.addEventListener("DOMContentLoaded", function () {
  var cartAttributes = document.getElementById("cart-attributes");
  var cartAttributesInputs = cartAttributes.querySelectorAll('#cart-attributes input[type="text"]');
  var cartAttributesSelects = document.querySelectorAll('.custom-select select');
  var form = document.getElementById("cart");
  var errorMissing = document.getElementById("error-missing");
  const rucInput = document.getElementById("ruc");
  var rucMissing = document.getElementById("ruc-missing");

  // Devuelve true si el campo (su contenedor .cart-attributes__field) está visible.
  // Con esto la validación solo exige los campos que corresponden al Tipo de Cliente elegido.
  function isFieldVisible(el) {
    if (!el) return false;
    var field = el.closest('.cart-attributes__field');
    return !!(field && field.offsetParent !== null);
  }

  // Quita el estado de error al seleccionar una opción válida
  function handleSelectChange() {
    if (this.value !== '') {
      this.classList.remove('missing');
    }
  }

  // Quita el estado de error al escribir
  function handleInputChange() {
    if (this.value.trim() !== "") {
      this.classList.remove('missing');
    }
  }

  // Validación de guiones de la cédula/RUC (sin cambios respecto al original)
  rucInput.addEventListener("input", function () {
    const guionCount = (rucInput.value.match(/-/g) || []).length;

    // Reinicia los estilos
    rucMissing.style.display = 'none';
    rucInput.classList.remove("missing");

    if (guionCount == 0) {
      // Aplica los estilos de error luego de tres segundos
      setTimeout(() => {
        rucMissing.style.display = 'block';
        rucInput.classList.add("missing");
      }, 3000);
    } else {
      setTimeout(() => {
        rucMissing.style.display = 'none';
        rucInput.classList.remove("missing");
      }, 3000);
    }
  });

  // El formulario ya no es opcional: la validación corre SIEMPRE.
  // Solo se validan los campos VISIBLES según el Tipo de Cliente seleccionado.
  // (Sin Tipo de Cliente elegido, ese select queda vacío y bloquea el checkout.)
  form.addEventListener("submit", function (event) {
    var visibleInputs = Array.from(cartAttributesInputs).filter(isFieldVisible);
    var visibleSelects = Array.from(cartAttributesSelects).filter(isFieldVisible);

    var areInputsFilled = visibleInputs.every(function (input) {
      return input.value.trim() !== "";
    });

    var areSelectsFilled = visibleSelects.every(function (select) {
      return select.value !== '';
    });

    // La cédula/RUC solo se valida si el campo está visible
    var isRucValid = true;
    if (isFieldVisible(rucInput)) {
      var guionCount = (rucInput.value.match(/-/g) || []).length;
      isRucValid = guionCount !== 0;
      if (!isRucValid) {
        setTimeout(() => {
          rucInput.classList.add("missing");
        }, 500);
      }
    }

    if (!areInputsFilled || !areSelectsFilled || !isRucValid) {
      event.preventDefault();

      visibleInputs.forEach(function (input) {
        if (input.value.trim() === "") {
          input.classList.add("missing");
        } else {
          input.classList.remove("missing");
        }
      });

      visibleSelects.forEach(function (select) {
        if (select.value === '') {
          select.classList.add('missing');
        } else {
          select.classList.remove('missing');
        }
      });

      errorMissing.classList.add("enabled");
    }
  });

  // Añade un event listener input a cada elemento input
  cartAttributesInputs.forEach(function (input) {
    input.addEventListener('input', handleInputChange);
  });

  cartAttributesSelects.forEach(function (select) {
    select.addEventListener('change', handleSelectChange);
  });
});
